module.exports = __webpack_public_path__ + "img/hr-concrete-side.4bed101d.png";